<template>
  <v-dialog v-model="show" persistent max-width="800px">
    <v-card class="mb-0">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Editar Producto</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-8" v-if="!loading">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="producto.codigo"
                prepend-icon="mdi-barcode"
                label="Código/SKU *"
                :rules="requiredRules"
                dense
                maxlength="50"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="producto.nombre"
                prepend-icon="mdi-package-variant"
                label="Nombre *"
                :rules="requiredRules"
                dense
                maxlength="100"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-textarea
                v-model="producto.descripcion"
                prepend-icon="mdi-text"
                label="Descripción"
                rows="2"
                dense
                maxlength="500"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="producto.precioCosto"
                prepend-icon="mdi-currency-usd"
                label="Precio de Costo *"
                :rules="precioRules"
                @keypress="onlyNumber"
                @blur="toFixedCosto"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="producto.precioVenta"
                prepend-icon="mdi-currency-usd"
                label="Precio de Venta *"
                :rules="precioRules"
                @keypress="onlyNumber"
                @blur="toFixedVenta"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                v-model="producto.stockActual"
                prepend-icon="mdi-package"
                label="Stock Actual"
                disabled
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                v-model="producto.stockMinimo"
                prepend-icon="mdi-alert"
                label="Stock Mínimo *"
                :rules="stockRules"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                v-model="producto.puntoReposicion"
                prepend-icon="mdi-reload"
                label="Punto de Reposición *"
                :rules="stockRules"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-select
                v-model="producto.unidadMedida"
                :items="unidadesMedida"
                label="Unidad de Medida *"
                :rules="requiredRules"
                dense
                prepend-icon="mdi-ruler"
              ></v-select>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="producto.fechaVencimiento"
                prepend-icon="mdi-calendar"
                label="Fecha de Vencimiento"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="producto.estado"
                :items="estados"
                label="Estado *"
                :rules="requiredRules"
                dense
                prepend-icon="mdi-check-circle"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text v-else>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        Cargando...
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click.stop="show = false">
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          :disabled="!valid || loading"
          @click.stop="actualizarProducto"
        >
          Actualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    idProducto: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      valid: false,
      lazy: false,
      loading: false,
      producto: {},
      unidadesMedida: [
        { text: "Unidad", value: "unidad" },
        { text: "Kilogramo", value: "kg" },
        { text: "Gramo", value: "g" },
        { text: "Litro", value: "litro" },
        { text: "Mililitro", value: "ml" },
        { text: "Metro", value: "metro" },
        { text: "Caja", value: "caja" },
        { text: "Pack", value: "pack" },
      ],
      estados: [
        { text: "Activo", value: "activo" },
        { text: "Inactivo", value: "inactivo" },
      ],
      requiredRules: [(v) => !!v || "Dato obligatorio"],
      precioRules: [
        (v) => !!v || "Dato obligatorio",
        (v) => parseFloat(v) >= 0 || "El precio debe ser mayor o igual a 0",
      ],
      stockRules: [
        (v) => (v !== null && v !== "") || "Dato obligatorio",
        (v) => parseFloat(v) >= 0 || "El stock debe ser mayor o igual a 0",
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    visible(val) {
      if (val && this.idProducto) {
        this.cargarProducto();
      }
    },
  },
  methods: {
    cargarProducto() {
      this.loading = true;
      let self = this;
      axios
        .get("/Producto/BuscarDatosProducto", {
          params: {
            idProducto: this.idProducto,
          },
        })
        .then(function (response) {
          if (response.data) {
            self.producto = response.data;
            // Convertir fecha de vencimiento al formato YYYY-MM-DD
            if (self.producto.fechaVencimiento) {
              self.producto.fechaVencimiento =
                self.producto.fechaVencimiento.split("T")[0];
            }
          }
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;
          self.showAlert({
            icon: "error",
            title: "Error al cargar el producto.",
            vm: self,
            timer: 2000,
          });
        });
    },

    toFixedCosto() {
      if (isNaN(parseFloat(this.producto.precioCosto)))
        this.producto.precioCosto = parseFloat(0.0).toFixed(2);
      else
        this.producto.precioCosto = parseFloat(
          this.producto.precioCosto,
        ).toFixed(2);
    },

    toFixedVenta() {
      if (isNaN(parseFloat(this.producto.precioVenta)))
        this.producto.precioVenta = parseFloat(0.0).toFixed(2);
      else
        this.producto.precioVenta = parseFloat(
          this.producto.precioVenta,
        ).toFixed(2);
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        $event.preventDefault();
      }
    },

    actualizarProducto() {
      this.$swal({
        title: "Actualizar Producto",
        text: "¿Desea actualizar este producto?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datos = {
            ...this.producto,
            usuario: this.$store.state.usuario.usuario,
          };

          let self = this;
          axios
            .post("/Producto/ModificarProducto", datos)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title:
                    "Ya existe un producto registrado con ese nombre o ese código",
                  vm: self,
                });
              } else {
                self.showAlert({
                  icon: "success",
                  title: "Producto actualizado exitosamente.",
                  vm: self,
                  timer: 2000,
                });
                self.$emit("actualizado");
                self.show = false;
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title:
                  error.response?.data || "No se pudo actualizar el producto.",
                vm: self,
                timer: 2000,
              });
            });
        }
      });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
  },
};
</script>
